import { createAction } from 'redux-actions';

export const onSwitchSearchBy = createAction(
  'GUESTS_SEARCH_ON_SWITCH_SEARCH_BY'
);

export const onChangeBarcodeInput = createAction(
  'GUESTS_SEARCH_ON_CHANGE_BARCODE'
);

export const onChangeColumnsInput = createAction(
  'GUESTS_SEARCH_ON_CHANGE_COLUMNS'
);

export const resetSearchInputs = createAction('GUESTS_SEARCH_RESET_INPUTS');
